<template>
    <div class="two-factor" :data-testid="TEST_ID.TWO_FACTOR.ROOT">
      <el-row class="container">
        <el-col :span="24">
          <!-- Header página -->
          <el-row>
            <el-col :xs="8" :sm="10" :md="12" :lg="14" :xl="16">
              <div class="title">{{ $t('TWO_FACTOR_AUTHENTICATION_twoFactorAuthentication') }}</div>
            </el-col>
          </el-row>

          <div v-if="is2FAEnabled || isActivateBtnClicked">
            <el-row class="section">
              <div class="section__title">{{ $t('TWO_FACTOR_AUTHENTICATION_authenticatorApp') }}</div>
              <dl>
                <p>
                  {{ $t('TWO_FACTOR_AUTHENTICATION_explanation') }}
                </p>
                <dt>{{ $t('TWO_FACTOR_AUTHENTICATION_item1') }}</dt>
                <dt>{{ $t('TWO_FACTOR_AUTHENTICATION_item2') }}</dt>
                <dt>{{ $t('TWO_FACTOR_AUTHENTICATION_item3') }}</dt>
                <dt>{{ $t('TWO_FACTOR_AUTHENTICATION_item4') }}</dt>
              </dl>
            </el-row>


            <el-row  class="section">
                <el-row class="qr-section">
                  <el-col class="qr-container">
                    <img :src="qrCodeSrc" alt="QR Code" class="qr-image" :data-testid="TEST_ID.TWO_FACTOR.QR" />
                  </el-col>
              </el-row>
                <el-row class="verify-section" :data-testid="TEST_ID.TWO_FACTOR.VERIFY">
                  <el-form @submit.prevent="saveCode">
                    <el-form-item>
                      <div class="code-container" :data-testid="TEST_ID.TWO_FACTOR.CODE_INPUTS">
                          <input 
                          v-for="(digit, index) in digits"
                          :key="index"
                          ref="inputs"
                          type="text"
                          maxlength="1"
                          class="code-input"
                          v-model="digits[index]"
                          @input="moveToNext(index)"
                          @keydown.backspace="moveToPrev(index)"
                          @keypress="onlyNumbers"
                          @keyup.enter="saveCode"
                          />
                          </div>
                      </el-form-item>
                      <el-button :data-testid="TEST_ID.TWO_FACTOR.SAVE_BUTTON" type="primary" @click="saveCode" :loading="this.guardandoTOTP" plain style="color:white !important;">
                          {{ $t('LOGIN_saveBtn') }}
                      </el-button>
                      <p v-if="is2FAEnabled" class="disable2FA" @click="showDisable2FAModal = true">{{ $t('TWO_FACTOR_AUTHENTICATION_deactivate2FA') }}</p>
                      <p v-else class="noDisable2FA">{{ $t('TWO_FACTOR_AUTHENTICATION_deactivate2FA') }}</p>
                  </el-form>
              </el-row>
            </el-row>
          </div>
          <div v-else>
            <el-row class="section" style="justify-content: center; display: flex;">
              <el-col class="col-center" :xs="8" :sm="10" :md="12" :lg="12" :xl="12">  
                <p class="reasonToActivate">{{ $t('TWO_FACTOR_AUTHENTICATION_reasonToActivate') }}</p>
                <el-icon class="security-icon" :data-testid="TEST_ID.TWO_FACTOR.LOCK"><Lock /></el-icon>
                <el-button :data-testid="TEST_ID.TWO_FACTOR.ACTIVATE_BUTTON" type="primary" @click="isActivateBtnClicked = true">
                  {{ $t('TWO_FACTOR_AUTHENTICATION_activateBtn') }}
                </el-button>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>

      <Disable2FAModal 
      v-if="showDisable2FAModal"
      :onCloseModal="onCloseDisable2FAModal" 
      :username="this.$store.state.sesion.resultadoAutenticacion.Usuario"
    />
    </div>
  </template>
  
  <script>

import { showError, showSuccess } from "../Mensaje";
import  Disable2FAModal from "./disable2FAModal.vue";
import TEST_ID from "@/testIds.json";
  export default {
    name: "TwoFactorAuthentication",
    components: { Disable2FAModal },
    data() {
      return {
        TEST_ID,
        qrCodeSrc: "", // Imagen QR
        code: "", // Código ingresado por el usuario
        isCodeValid: false, // Validez del código ingresado
        key: "", // Clave secreta generada por el backend
        digits: Array(6).fill(""),
        isActivateBtnClicked: false,
        showDisable2FAModal: false,
        is2FAEnabled: this.$store.state.sesion.resultadoAutenticacion.TOTPActivo,
        guardandoTOTP : false
      };
      
    },
    mounted(){
      // Generar el código QR
      this.generateQRCode();
    },
    methods: {
      onlyNumbers(event) {
        const charCode = event.keyCode || event.which;
        // Permitir únicamente los caracteres del 0 al 9
        if (charCode < 48 || charCode > 57) {
          event.preventDefault(); // Evita que se ingrese cualquier otro carácter
        }
      },
      saveCode() {
        this.guardandoTOTP = true;
        this.code = this.digits.join("");
        if(this.code.length !== 6){
          this.guardandoTOTP = false;
          showError(this.$t("TWO_FACTOR_AUTHENTICATION_requiredField"));
          return;
      }
      else{
        const payload = {
          usuario: this.$store.state.sesion.resultadoAutenticacion.Usuario,
          codigo: this.code,
          secreto: this.key
        };
        this.$store.dispatch('sesion/guardarTOTP', payload)
        .then(resultado => {
          if (resultado !== undefined) {
            if(resultado === 0){//Código guardado correctamente
              this.is2FAEnabled = true; // temporal
              this.$store.state.sesion.resultadoAutenticacion.TOTPActivo = true;
              showSuccess(this.$t('TWO_FACTOR_AUTHENTICATION_codeSaved'));
              this.code = "";
              this.digits = Array(6).fill("");
              this.guardandoTOTP = false;
            }
            else{
              showError(this.$t('TWO_FACTOR_AUTHENTICATION_verifyError'));
              this.guardandoTOTP = false;
            }
          } else {
            showError(this.$t("TWO_FACTOR_AUTHENTICATION_verifyError"));
            this.guardandoTOTP = false;
          }
        });
      }
    },
      generateQRCode() {
        const payload = {
          usuario: this.$store.state.sesion.resultadoAutenticacion.Usuario
        };
        this.$store.dispatch("sesion/generarQRCode",payload)
        .then(resultado => {
          if (resultado !== undefined) {
            this.qrCodeSrc = "data:image/png;base64," + resultado.imagenBase64;
            this.key = resultado.claveSecreta;
          }else{
            showError("Error al generar el código QR.");
          }
        });
      },
      moveToNext(index) {
      if (this.digits[index] && index < this.digits.length - 1) {
        this.$refs.inputs[index + 1].focus();
      }
    },
    moveToPrev(index) {
      if (!this.digits[index] && index > 0) {
        this.$refs.inputs[index - 1].focus();
      }
    },
    onCloseDisable2FAModal(shouldDisable) {
      this.showDisable2FAModal = false;
      if (shouldDisable) {
        this.is2FAEnabled = false;
        this.isActivateBtnClicked = false;
        this.code = "";
        this.digits = Array(6).fill("");
        this.$store.state.sesion.resultadoAutenticacion.TOTPActivo = false;
      }
    }
    },
  };

</script>


<style scoped>
.container {
    display: flex;
    padding: 20px 40px;
}
  
  @media (max-width: 600px) {
    .container {
      padding: 20px 10px;
    }
    .col-empresa {
      flex: 1;
      width: 100% !important;
    }
    .img_container_responsive {
      display: block;
      text-align: center !important;
    }
    .img_container {
      display: none;
    }
    .direccion {
      width: 100% !important;
    }
    .col-card-modal {
      width: 100%;
    }
    .card_list_item_modal {
      width: 70% !important;
    }
   
  }
  @media (max-width: 786px){
    .card_list_item_modal {
      width: 100%;
    }
  
  }
  
  .title {
    font-size: 22px;
    font-weight: bold;
    text-align: left;
    color: var(--main-color);
  }
  .section {
    padding: 15px 0;
  }

  .col-center {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  
  .section__title {
    font-size: 20px;
    line-height: 23px;
    color: var(--main-color);
    text-align: left;
  }
  .cards_container {
    display: flex;
    flex-wrap: wrap;
    margin-top: 15px;
    width: 100%;
  }
  .card_empresa {
    flex: 1;
    text-align: left;
  }
  .label {
    font-size: 14px;
    line-height: 25px;
    color: #555555;
    display: inline-block;
  }
  .label_value {
    font-size: 14px;
    font-weight: bold;
    line-height: 25px;
    color: #000000;
    display: inline-block;
  }
  
  .lineas {
    display: flex;
    flex-direction: column;
  }
  .card_nro_mail {
    text-align: left;
    flex: 1 0 350px;
    margin-bottom: 15px;
    max-width: 50%;
  }
  .telefonos_asoc_link {
    line-height: 25px;
    vertical-align: bottom !important;
    color: var(--main-color);
    cursor: pointer;
    margin-top: 5px;
  }
  .button {
    position: fixed;
    bottom: 40px;
    right: 40px;
  }
  .modal_title {
    font-size: 22px;
    font-weight: bold;
    text-align: left;
    color: var(--main-color);
    margin-bottom: 20px;
    text-align: left;
  }
  .modal_body {
    /*display: flex; */
    border-top: 1px solid #ececec;
    border-bottom: 1px solid #ececec;
    flex-wrap: wrap;
  }
  
  .empty_state {
    display: flex;
    height: 50vh;
    align-items: center;
    justify-content: center;
    color: #999;
  }
  dl{
    text-align: left;
  }
  </style>
  
<style>
  .qr-section {
  display: flex;
  width: 100%;
  margin-bottom: 20px;
  justify-content: center;
}

.qr-container {
  display: flex;
  width: 100%;
  justify-content: center;
}

.qr-image {
  width: min(260px, 100%);
  max-width: 260px;
  height: auto;
  aspect-ratio: 1;
  object-fit: contain;
}
.verify-section {
  display: flex;
  width: 100%;
  margin-bottom: 20px;
  justify-content: center;
}
.verify-section form {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
}
.verify-section .el-form-item {
  display: flex;
  width: 100%;
  justify-content: center;
}
.code-container {
  display: flex;
  width: 100%;
  box-sizing: border-box;
  gap: 10px;
  justify-content: center;
}

.code-input {
  width: 50px;
  height: 60px;
  box-sizing: border-box;
  font-size: 30px;
  text-align: center;
  border: 1px solid #333;
  border-radius: 15px;
  margin: 0px 2px 0px 2px;
}
.security-icon{
  font-size: 50px;
  color: #333;
  display: block;
  padding: 10px;
  margin: 10px auto;
}
.disable2FA{
  color: #645c5c;
  cursor: pointer;
  text-decoration: underline;
  font-size: 13px;
}
.noDisable2FA{
  color: #645c5c;
  cursor: not-allowed;
  text-decoration: underline;
  font-size: 13px;
}
.reasonToActivate{
  text-align: center;
  margin: 50px 0px 10px 0px; 
}

@media (max-width: 600px) {
  .qr-image {
    width: min(260px, 80vw);
  }

  .code-input {
    width: 38px;
    height: 50px;
    font-size: 24px;
    margin: 0 1px;
  }
}
</style>